import { render, staticRenderFns } from "./intransfers.vue?vue&type=template&id=8f56063a&scoped=true&"
import script from "./intransfers.vue?vue&type=script&lang=js&"
export * from "./intransfers.vue?vue&type=script&lang=js&"
import style0 from "./intransfers.vue?vue&type=style&index=0&id=8f56063a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56063a",
  null
  
)

export default component.exports